module.exports = {"liang":[{"name":"2015","value":60},{"name":"2016","value":65},{"name":"2017","value":70},{"name":"2018","value":90},{"name":"2019","value":91},{"name":"2020","value":95}],"number":[{"name":"2015","value":45},{"name":"2016","value":60},{"name":"2017","value":61},{"name":"2018","value":65},{"name":"2019","value":70},{"name":"2020","value":80}]}


//////////////////
// WEBPACK FOOTER
// ./src/module/monitoringCenter/jsons/json20.json
// module id = gI68
// module chunks = 56